import type {AiChatGeneratedAsset, AiChatGeneratedAssetFilter} from '@AiChat/ai-chat.types';

export const AI_CHAT_ASSETS_GRID_ID = 'ai-chat-generated-assets-grid';
export const ASSETS_GRID_ITEM_HEIGHT = 180;
export const ASSETS_GRID_ITEM_HEIGHT_MOBILE = 123;
export const ASSETS_GRID_ITEM_GAP = 12;
export const ASSETS_GRID_ITEM_GAP_MOBILE = 8;
export const ASSETS_GRID_BATCH_SIZE = 30;

export interface AiChatAssetsGridProps {
  filter: AiChatGeneratedAssetFilter;
  scrollingContainer: HTMLDivElement | null;
  onAssetClick: (asset: AiChatGeneratedAsset) => void;
}
